import EventInfo from './EventInfo';
import { EventInfoProps, EventInfoValueProps } from './types';

export type { EventInfoProps, EventInfoValueProps };
export default EventInfo;
